// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"df7351b8","513":"857328bf","703":"222e4092","787":"02315ebe"}[chunkId] + ".chunk.js";
};